import React from "react";
import { tokens } from "../../public/tokens.js";

const styles = {
    markChip: {
        display: "flex",
        height: "18px",
        padding: "4px",
        alignItems: "center",
        gap: "4px",
        alignItems: "baseline",
        borderRadius: tokens.globals["border-radius"],
        textAlign: "center",
        fontFeatureSettings: "'liga' off, 'clig' off",
        fontSize: tokens.typography.fontSize["sm-10px"],
        fontStyle: "normal",
        fontWeight: tokens.typography.fontWeights.bold,
        lineHeight: "100%",
    },

    passed: {
        backgroundColor: tokens.colors.neutral["grey"]["100"],
        color: tokens.colors.brand["fresh-green"]["900"],
    },
    condoned: {
        backgroundColor: tokens.colors.neutral["grey"]["100"],
        color: tokens.colors.brand["veld-sprout"]["900"],
    },

    failed: {
        backgroundColor: tokens.colors.neutral["grey"]["100"],
        color: tokens.colors.brand["red"]["900"],
    },
};

/**
* Displays a module mark with a pass/fail indicator and styling used on module tiles.
* @param {boolean} passed - Whether the module was passed.
* @param {number|string} mark - The module mark percentage.
*/
export default function MarkChip({ passed, mark }) {
    const isPassed = passed === "PASS" || passed === "CONDONED";

    if (passed == null || passed === "witheld") return null;
    
    const stateStyle = passed === "PASS" ? styles.passed : passed === "CONDONED" ? styles.condoned : styles.failed;

    return (
        <span style={{ ...styles.markChip, ...stateStyle }}>
            <i
                className={`fa-solid ${isPassed ? "fa-circle-check" : "fa-circle-xmark"}`}
                style={{ marginRight: "2px" }}
            />
            {mark}
        </span>
    );
}